import React from "react";
import { useNavigate } from "react-router-dom";
import Terminal from "../components/Terminal";

export const ConsolePage: React.FC = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate(-1); // Go back to previous page
  };

  return (
    <div style={{ 
      position: 'fixed', 
      top: 0, 
      left: 0, 
      right: 0, 
      bottom: 0, 
      zIndex: 9999,
      background: '#000000'
    }}>
      <Terminal onClose={handleClose} />
    </div>
  );
};
